import React, { useContext } from 'react';
import { Redirect } from 'react-router';
import { AuthContext } from '../../../contexts/AuthContext';

export default function Settings() {
  const { state } = useContext(AuthContext);
  return (
    <div>
      {state.isAuth ? (
        <Redirect to="/dashboard/settings" />
      ) : (
        <Redirect to="/login" />
      )}
    </div>
  );
}
